import { useContext } from "react";
import { PropertyInventoryContext } from "../context/PropertyInventoryContext";

export const usePropertyInventory = () => {
  const context = useContext(PropertyInventoryContext);
  if (!context) {
    throw new Error('usePropertyInventory debe usarse dentro de PropertyInventoryProvider');
  }
  return context;
};